import React from 'react';
import Select from 'react-select';
import {setOption} from './FormAction';
import {connect} from 'react-redux';
import {LoadCategoryOptions} from './FormUtils';
// import * as _ from 'lodash';

class SelectCarModel extends React.Component {

  constructor(...props) {
    super(...props);
    // this.initial();
    this.state = {_brand_id:'0'}
  }

  componentWillReceiveProps(newProps) {
    let brand_id = '0'
    let {_brand_id} = this.state
    if (typeof newProps.uiSchema.type!=='undefined'&&newProps.uiSchema.type==="vehicle")
      brand_id = (newProps.formContext.formData.vehicle!==null?newProps.formContext.formData.vehicle.brand_id:'0')
    else
      brand_id = (newProps.formContext.formData.car!==null?newProps.formContext.formData.car.brand_id:'0')
    
    if (brand_id!=='0'&&brand_id!==_brand_id)
      this.loadCategoryOptions(brand_id)
  }

  // initial() {
  //   try {
  //     LoadCategoryOptions(this.props.formContext.formData.car.brand_id)
  //         .then(options => this.props.setOption({
  //           model_options: options,
  //         }));
  //   } catch (ex) {}
  // }

  loadCategoryOptions(brand_id) {
    try {
      this.setState({_brand_id:brand_id})
      LoadCategoryOptions(brand_id)
          .then(options => this.props.setOption({
            model_options: options,
          }));
    } catch (ex) {}
  }

  onFormChange = (e) => {
    // {
    //   model_id: e.value,
    //       model: e.label,
    // }
    const {uiSchema} = this.props
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    let evalue = multi?e:e;
    // console.log('evalue=>',evalue)
    let evalue_search = multi?e:[e];
    this.props.onChange(evalue);
    
    if(evalue_search.length===1){
      LoadCategoryOptions(evalue_search[0].value).then(options => {
        this.props.setOption({
          series_options: options
        })
      });
    }else{
      
    }

  };

  render() {
    const {
      store,
      formData,
      uiSchema
    } = this.props;
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    return (
        <Select
            multi={multi}
            removeSelected={true}
            readOnly={this.props.readonly}
            disabled={this.props.disabled}
            placeholder={'โปรดระบุ'}
            clearable={false}
            value={formData}
            options={store.options.model_options}
            onChange={this.onFormChange}
        />
    );
  }
}

const mapStateToProps = (state) => ({
  store: state,
});

const mapDispatchToProps = ({
  setOption,
});

const container = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectCarModel);

export default container;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/SelectCarModel.js